/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGridViewSmall = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 16v6H9v-6zm7 0v6h-6v-6zM8 16v6H2v-6zm5 2h-2v2h2zm7 0h-2v2h2zM6 18H4v2h2zm9-9v6H9V9zm7 0v6h-6V9zM8 9v6H2V9zm5 2h-2v2h2zm7 0h-2v2h2zM6 11H4v2h2zm9-9v6H9V2zm7 0v6h-6V2zM8 2v6H2V2zm5 2h-2v2h2zm7 0h-2v2h2zM6 4H4v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGridViewSmall as GridViewSmall };
